import React from "react"
import { useParams } from "react-router-dom"
import AdminFlags from "../Flags/Flags"

/**
 * Manage City — Flags & Reports.
 * GET /api/v1/admin/flags?city_id=
 */
const AdminCityFlags = () => {
  const { cityId } = useParams()

  return (
    <AdminFlags
      documentTitle="Flags & Reports | AMOK . EARTH Admin"
      cityId={cityId}
    />
  )
}

export default AdminCityFlags
